<div class="introduce">
  <div class="title">
    云登GPT介绍
    <img
      width="62"
      height="62"
      src="../../../../assets/images/yunlogin/title-icon.webp"
      alt="icon"
    />
  </div>
  <div class="content1">
    <div class="why">为什么选择云登GPT？</div>
    <div class="reason">
      云登GPT基于云登浏览器打造，提供安全稳定的网络环境和独特的指纹技术，有效规避账号封禁风险。<br />云登GPT的优势包括：
    </div>
  </div>
  <div class="content2">
    <div class="item" *ngFor="let data of reason">
      <img width="93" height="89" [src]="data.img" alt="icon" />
      <div class="text1">{{ data.text1 }}</div>
      <div class="text2">{{ data.text2 }}</div>
    </div>
  </div>
</div>
<div class="tutorial">
  <div class="title">
    使用教程
    <img
      width="62"
      height="62"
      src="../../../../assets/images/yunlogin/title-icon.webp"
      alt="icon"
    />
  </div>
  <div class="item">
    <div class="pic">
      <img
        width="564"
        height="330"
        src="../../../../assets/images/yunlogin/step1.webp"
        alt="step"
      />
    </div>
    <div class="content" style="margin-left: 30px">
      <div class="step"><span>下载云登</span>浏览器</div>
      <div class="detail">
        云登浏览器作为载体，提供了安全的网络和 指纹环境，避免账号被官方封禁。
      </div>
      <div class="detail button" (click)="download()">立即下载></div>
    </div>
  </div>
  <div class="item">
    <div class="content" style="margin-left: 70px; margin-right: 30px">
      <div class="step"><span>登录云登</span>浏览器</div>
      <div class="detail">
        无需注册，使用登录环球巴士的同一手机号登录云登浏览器，即可启用 ChatGPT。
      </div>
    </div>
    <div class="pic">
      <img
        width="564"
        height="330"
        src="../../../../assets/images/yunlogin/step2.webp"
        alt="step"
      />
    </div>
  </div>
  <div class="item">
    <div class="pic">
      <img
        width="564"
        height="330"
        src="../../../../assets/images/yunlogin/step3.webp"
        alt="step"
      />
    </div>
    <div class="content" style="margin-left: 30px">
      <div class="step"><span>立即使用</span></div>
      <div class="detail">
        在云登浏览器客户端的首页即可一键启动ChatGPT，无需海外网络环境。
      </div>
    </div>
  </div>
  <div class="item">
    <div class="content" style="margin-left: 70px; margin-right: 30px">
      <div class="step"><span>切换账号</span></div>
      <div class="detail">
        当ChatGPT
        Plus4.0提问上限之后，先关闭打开的窗口，再点击“更换”按钮即可继续使用。
      </div>
    </div>
    <div class="pic">
      <img
        width="564"
        height="330"
        src="../../../../assets/images/yunlogin/step4.webp"
        alt="step"
      />
    </div>
  </div>
</div>
<div class="question">
  <div class="title">
    常规问题
    <img
      width="62"
      height="62"
      src="../../../../assets/images/yunlogin/title-icon.webp"
      alt="icon"
    />
  </div>
  <mat-accordion>
    <mat-expansion-panel *ngFor="let data of list">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ data.title }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <p>
        {{ data.content }}
      </p>
    </mat-expansion-panel>
  </mat-accordion>
</div>
